import { render } from "./Dashboard.vue?vue&type=template&id=0195896d&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0195896d&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=0195896d&lang=css"
script.render = render
script.__scopeId = "data-v-0195896d"

export default script